<a type="button" class="btn btn-default" *ngFor="let r of touchTiles" [style.background-color]='r.color'
  [class.disabled]='!r.enabled'>{{ r.name }}</a>
<a type="button" class="btn btn-default" (click)="testChangeColorsClick()">{{ 'Test change colors' | translate }}</a>
<a type="button" class="btn btn-default" (click)="testChangeSwitchesClick()">{{ 'Test change switches' | translate }}</a>
<a type="button" class="btn btn-default" [style.background-image]='scenarioGradient'>
  {{'Running light'| translate }}: {{ runningLightScenario}}</a>
